import { render, staticRenderFns } from "./FacebookButtonAgeGate.vue?vue&type=template&id=2428bf88&scoped=true"
import script from "./FacebookButtonAgeGate.vue?vue&type=script&lang=js"
export * from "./FacebookButtonAgeGate.vue?vue&type=script&lang=js"
import style0 from "./FacebookButtonAgeGate.vue?vue&type=style&index=0&id=2428bf88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2428bf88",
  null
  
)

export default component.exports